module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"signIn":"Anmelden","signOut":"Abmelden"},"en":{"signIn":"Sign in","signOut":"Sign out"}}')
  delete Component.options._Ctor
}
